var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.375,
    width: 16,
    height: 27,
    fill: "url(#pattern0_161_87)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_161_87",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_161_87",
    transform: "matrix(0.0104167 0 0 0.00617284 0 0.203704)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_161_87",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABaElEQVR4nO2bwU0EQRDELogShDUvOkfmRVgggiiCaOmsE3YGW9Z6+x73eIiIiIiIiIiIiDyJtrc7PpS1E5C23wsBv23flbCTcJZvwZcCltQUsdQU8dQU8dQU4QLiVcRLOF5FvIS7lOAPtKWAmCKYmiKemiJcQEwRL+F4FfESrlcRKyCmCKamiKemCBcQU8RLOF5FvITrVcQKiCmCqSniqSnCBcQU8RKOVxEv4XoVsQJiimBqinhqinABMUW8hONVxEu4XkWsgJgimJoiXMAsM/QJP8LLJ+hn+d+zN/o5Xpb6EUbHH9PDjR/TA1LTg44/pocbP6YHpKYHHX9MDzd+TA9ITQ86/pgebvyYHpCaHnT8MT3c+DE9IDU96PhjerjxY3pAanrQ8cf0cOPH9IDU9KDjj+nhxo/pAanpQccf08ONH9MDUtODjj+mhxs/pgekpgcdf0wPN35MD0hNj4iIiIiIiIiIPP4HfySeDf6V6laqAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.91b4ff6d50e76c13f2bdb25b787295ef.svg";
export { ForwardRef as ReactComponent };